export default __webpack_public_path__ + "static/pontusab-ce50cf14d4fc2c61598aae27e9d732b5.jpg";